/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    func, bool, number, string,
} from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { clubComponentType } from '../common/types';
import ClubPDPDialogSlider from './ClubPDPDialogSlider';

const useStyles = makeStyles((theme) => ({
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
    monthList: {
        display: 'flex',
    },
    monthDetailContainer: {
        display: 'flex',
        position: 'relative',
        margin: '0 auto',
        maxWidth: 1080,
    },
    leftNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    monthDescriptionSummary: {
        minWidth: '500px',
        marginLeft: '50px',
        [theme.breakpoints.down('md')]: {
            marginLeft: '0px',
            minWidth: '254px',
        },
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        maxWidth: '300px',
        minWidth: '300px',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    nextNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(-90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    flexContainer: {
        display: 'flex',
    },
    wrapper: {
        maxWidth: '80%',
        [theme.breakpoints.down(1640)]: {
            maxWidth: '100%',
        },
    },
    wrapper3Nup: {
        maxWidth: '50%',
        [theme.breakpoints.down(1640)]: {
            maxWidth: '80%',
        },
    },
    wrapper9Nup: {
        maxWidth: '65%',
        [theme.breakpoints.down(1640)]: {
            maxWidth: '80%',
        },
        [theme.breakpoints.down(1200)]: {
            maxWidth: 'calc(100% - 64px)',
        },

    },
    wrapper6Nup: {
        maxWidth: '55%',
        [theme.breakpoints.down(1400)]: {
            maxWidth: '70%',
        },
        [theme.breakpoints.down(1200)]: {
            maxWidth: 'calc(100% - 64px)',
        },
    },
}));

const ClubPDPDialog = ({
    handleState, getSlides, cdnLink, modalOpen, selectedComponentMonth, clubComponents, navigate,
}) => {
    const classes = useStyles();

    const renderCss = (style) => {
        let  styling = style.wrapper;
        switch (clubComponents.length) {
            case 3:
                styling = style.wrapper3Nup;
                break;
            case 9:
                styling = style.wrapper9Nup;
                break;
            case 6:
                styling = style.wrapper6Nup;
                break;
            default:
                return styling;
        }
        return styling;
    };

    return (
        <Dialog
            open={modalOpen}
            maxWidth={false}
            classes={{
                paper: renderCss(classes),
            }}
            onClose={() => { handleState({ modalOpen: false, selectedComponentMonth: 0 }); }}
        >
            <DialogTitle>
                <CloseIcon data-testid="club-component-detail-modal-close" onClick={() => { handleState({ modalOpen: false, selectedComponentMonth: 0 }); }} className={classes.closeIcon} />
            </DialogTitle>
            <DialogContent data-testid="club-component-detail-modal">
                <ClubPDPDialogSlider  data={getSlides(clubComponents, true)} cdnLink={cdnLink} navigate={navigate} clubComponents={clubComponents} selectedComponentMonth={selectedComponentMonth} renderCss={renderCss} />
            </DialogContent>
        </Dialog>
    );
};
ClubPDPDialog.propTypes = {
    handleState: func,
    clubComponents: clubComponentType.isRequired,
    getSlides: func,
    navigate: func,

    modalOpen: bool,
    cdnLink: string,
    selectedComponentMonth: number,
};
ClubPDPDialog.defaultProps = {
    handleState: () => { },
    getSlides: () => { },
    navigate: () => { },
    modalOpen: false,
    cdnLink: '',
    selectedComponentMonth: 0,
};
export default ClubPDPDialog;
